module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	
	fox.registerWidget('Catalog_List_VR', {

		configure: function () {
			this.registerOptions('', {
				template: 'catalog_home_vrlist_grid',
				'widgets.eventsList': {
					'widgets.list.tpl.row': 'catalog_events_item_vr_model'
				}
			});

			this.callParent('configure', arguments);
		},
		
		init: function () {
			this.registerOptions('#eventsDl', {
				method: 'Portal.getModelsFeed',
				transitParameters: {withVrContent: 1}
				
			});
			this.registerOptions('#moreEventsDl', {
				method: 'Portal.getModelsFeed',
				transitParameters: {withVrContent: 1}
			});
			this.callParent('init', arguments);
		}
	}, 'Catalog_List_Models');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/catalog/catalog3x/list/vrlist.js
// module id = 123
// module chunks = 0